var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/expand") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-60.0%",
    y: "-60.0%",
    width: "220.0%",
    height: "220.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.129411765   0 0 0 0 0.239215686   0 0 0 0 0.345098039  0 0 0 0.4 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/expand",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#40B3DB",
    opacity: 0.299999982,
    cx: 10,
    cy: 10,
    r: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74162879,9.51042673 L10.9171197,5.33516661 C11.1184303,5.13385598 11.4449962,5.13385598 11.6462859,5.33516661 L12.1333548,5.82221455 C12.3344347,6.02329439 12.3346445,6.3490001 12.1341941,6.55052054 L8.82497877,9.87500983 L12.1339842,13.1997089 C12.3346445,13.4012294 12.3342249,13.7269351 12.133124,13.9280359 L11.6460761,14.4150838 C11.4447655,14.6163945 11.1182205,14.6163945 10.9169099,14.4150838 L6.74162879,10.2395929 C6.54033914,10.0382823 6.54033914,9.71173737 6.74162879,9.51042673 Z",
    id: "right-chevron",
    fill: "#40B3DB",
    fillRule: "nonzero",
    opacity: 0.5,
    transform: "translate(9.437505, 9.875125) scale(-1, 1) translate(-9.437505, -9.875125) "
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.26374069.svg";
export { ForwardRef as ReactComponent };